import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericDropdownComponent } from './generic-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [GenericDropdownComponent],
  exports: [GenericDropdownComponent],
})
export class GenericDropdownModule { }
